import { Line } from "react-chartjs-2";
import ChartCard from "./ChartCard";

export const WeeklyChart = ({ data }) => {
    if (!data || data.length === 0 || !data[0]?.yearly_data) {
        return (
            <div className="text-center text-gray-400 py-10">
                No weekly data available
            </div>
        );
    }

    const labels = data[0]?.yearly_data?.dailylabel || [];

    const isInvalidValue = (value) =>
        value === 0 || value === null || value === "0.0";

    const colors = [
        { border: "#dc2626", bg: "rgba(220,38,38,0.15)" },
        { border: "#2563eb", bg: "rgba(37,99,235,0.15)" },
        { border: "#16a34a", bg: "rgba(22,163,74,0.15)" },
    ];

    const datasets = data.map((yearData, index) => ({
        id: index,
        label: `Year ${yearData.year}`,
        data:
            yearData?.yearly_data?.dailytotal?.map((v) =>
                isInvalidValue(v) ? null : v
            ) || [],
        borderColor: colors[index]?.border || "#111827",
        backgroundColor: colors[index]?.bg || "rgba(0,0,0,0.1)",
        tension: 0.4,
        fill: true,
        pointRadius: 3,
    }));

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false,
        },
        plugins: {
            legend: {
                position: "top",
                labels: {
                    color: "#374151",
                    font: {
                        size: 12,
                        weight: "500",
                    },
                    usePointStyle: true,
                    pointStyle: "circle",
                },
            },
            tooltip: {
                backgroundColor: "#111827",
                titleColor: "#fff",
                bodyColor: "#fff",
                padding: 10,
                cornerRadius: 8,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: "#6b7280",
                },
            },
            y: {
                grid: {
                    color: "rgba(209,213,219,0.3)",
                },
                ticks: {
                    color: "#6b7280",
                },
            },
        },
    };

    return (
        <ChartCard title="Weekly Comparison">
            <Line data={{ labels, datasets }} options={chartOptions} />
        </ChartCard>
    );
};